<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
					<el-form-item>
						<div style="font-size: 16px;font-weight: bold;color: #111111;">账户余额：300.00</div>
					</el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:plattransactiondetais:zijin')" type="primary" @click="deleteHandle()">充值</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" v-if="$hasPermission('plat:plattransactiondetais:jypwd')" @click="exportHandle()">设置支付密码</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" style="text-align: right;" :model="dataForm" @keyup.enter.native="getDataList()">
					<el-form-item>
						<el-button type="primary" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="info" @click="getDataList()">刷新</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/wofangxinxi-icon.png" />
				交易记录
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" style="text-align: right;" :model="dataForm" @keyup.enter.native="getDataList()">
					<el-form-item>
						<el-button v-if="$hasPermission('plat:plattransactiondetais:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:plattransactiondetais:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
					</el-form-item>
					<el-form-item class="el-form-item-btn" style="margin-right: 10px;">
						<upload-btn type="info" ref="upload" :uploadUrl="uploadUrl" :uploadType="uploadType" :multiple="multiple" v-on:backSuccess="backSuccess" :btnSize="btnSize"></upload-btn>
					</el-form-item>
					<el-form-item>
						<el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>

					<el-form-item class="el-form-item-btn">
							<a :href="`${publicPath}template/jymx.xls`" target="_blank" download="jymx.xls" style="text-decoration: underline;color:#3878F4">下载模板</a>

					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div class="mod-plat__plattransactiondetais}">
			<el-form :inline="true" style="padding-top: 20px;text-align: right;" :model="dataForm" @keyup.enter.native="getDataList()">
				<el-form-item>
					<el-select v-model="dataForm.myAccountTitle" placeholder="我方主体名称" clearable filterable>
						<el-option v-for="platBody in platBodyList" :key="platBody.id" :label="platBody.bodyName" :value="platBody.bodyName"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-date-picker
						v-model="dataForm.startDate"
						type="date"
						placeholder="选择开始日期"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						default-time="00:00:00"
					/>
				</el-form-item>
				<el-form-item>
					<el-date-picker
						v-model="dataForm.endDate"
						type="date"
						placeholder="选择结束日期"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						default-time="00:00:00"
					/>
				</el-form-item>

				<el-select v-model="dataForm.timeSlot" placeholder="请选择" @change="updateByTimeSlot" clearable filterable>
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
				</el-select>

				<el-form-item>
					<el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
				</el-form-item>

			</el-form>
			<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
				<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
				<el-table-column label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="myAccountTitle" label="我方账号名称" header-align="center" align="center"></el-table-column>
				<el-table-column prop="myBankAccount" label="我方银行账号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="businessDate" label="业务日期" header-align="center" align="center"></el-table-column>
				<el-table-column prop="summary" label="摘要" header-align="center" align="center"></el-table-column>
				<el-table-column prop="businessType" label="业务类型" header-align="center" align="center"></el-table-column>
				<el-table-column prop="theirAccountTitle" label="对方账号名称" header-align="center" align="center"></el-table-column>
				<el-table-column prop="theirBankAccount" label="对方银行账号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="incomeAmount" label="收入金额" header-align="center" align="center"></el-table-column>
				<el-table-column prop="expenditureAmount" label="支出金额" header-align="center" align="center"></el-table-column>
				<el-table-column prop="downloadReq" label="流水号" header-align="center" align="center"></el-table-column>
				<el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
					<template slot-scope="scope">
						<el-button v-if="$hasPermission('plat:plattransactiondetais:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">
							{{ $t('update') }}
						</el-button>
						<el-button v-if="$hasPermission('plat:plattransactiondetais:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">
							{{ $t('delete') }}
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="limit"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
				@size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle"
			></el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		</div>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './plattransactiondetais-add-or-update'
import uploadBtn from '../uploadBtn'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      publicPath: process.env.BASE_URL,
      options: [
        {
          value: '0',
          label: '本日'
        },
        {
          value: '-7',
          label: '近一周'
        },
        {
          value: '-30',
          label: '近一月'
        },
        {
          value: '-120',
          label: '近三月'
        },
        {
          value: '-180',
          label: '近半年'
        },
        {
          value: '-365',
          label: '近一年'
        }
      ],
      value: '',
      uploadUrl: '/sys/plat/plattransactiondetais/importFile', // 上传附件组件传值:上传的action
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/plattransactiondetais/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/plattransactiondetais',
        deleteIsBatch: true,
        exportURL: '/sys/plat/plattransactiondetais/export'
      },
      platBodyList: [],
      dataForm: {
        myAccountTitle: '',
        startDate: '',
        endDate: '',
        timeSlot: ''
      }
    }
  },
  components: {
    AddOrUpdate,
    uploadBtn
  },
  methods: {
    // 获取数据填充数据
    updateByTimeSlot () {
      this.dataForm.startDate = this.GetDateStr(this.dataForm.timeSlot)
      this.dataForm.endDate = this.getdataTime()
    },
    // 获取当前日期时间
    getdataTime () {
      var now = new Date()
      var year = now.getFullYear() // 得到年份
      var month = now.getMonth() // 得到月份
      var date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')

      var defaultDate = `${year}-${month}-${date}`
      return defaultDate
    },
    // 上传成功
    backSuccess (datas) {
      this.query()
    },
    GetDateStr (days) {
      var AddDayCount = parseInt(days)
      var dd = new Date()
      dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1 // 获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate() // 获取当前几号，不足10补0
      return y + '-' + m + '-' + d
    },
    // 获取我方主体列表
    getPlatBodyList () {
      this.$http
        .get('/sys/plat/body/list')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.platBodyList = res.data
        })
        .catch(() => {})
    }
  },
  created () {
    this.getPlatBodyList()
  }
}
</script>
